export const OPENING_HOURS = [
    {
        period: 'Final week – Week 43 (19–25 Oct)',
        hours: ['Friday & Saturday 21:00–02:00'],
    },
    {
        period: 'Reopening – Week 47',
        hours: ['20 November', 'Join us for our Christmas Table (Julbord)'],
    },
] as const;
